import { Textarea } from "@inno-ui/textarea";

import { useFieldContext } from "../../hooks/use-form";

type TextAreaFieldProps = {
  placeholder: string;
  label: string;
};

export function TextAreaField({ placeholder, label }: TextAreaFieldProps) {
  const field = useFieldContext<string>();

  return (
    <Textarea
      placeholder={placeholder}
      errorText={field.state.meta.errors[0]?.message}
      label={label}
      name={field.name}
      width="100%"
      isLabelTruncate={false}
      isResizable={false}
      value={field.state.value}
      onChange={e => field.handleChange(e.target.value)}
    />
  );
}
